import { compose } from 'redux';
import { withPlugins } from '../extend/withPlugins';
import { WindowTopBarPluginMenu } from '../components/WindowTopBarPluginMenu';

const enhance = compose(withPlugins('WindowTopBarPluginMenu'));

export default enhance(WindowTopBarPluginMenu);
